/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Reset_PendingInputs */

const en_error_mfa_reset_pending = /** @type {(inputs: Error_Mfa_Reset_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A reset of this user's second factors already waits for an approval.`)
};

/**
* | output |
* | --- |
* | "A reset of this user's second factors already waits for an approval." |
*
* @param {Error_Mfa_Reset_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_reset_pending = /** @type {((inputs?: Error_Mfa_Reset_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Reset_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_reset_pending(inputs)
});